import { visibilitySlice } from './slice';

export const visibilitySettingsReducer = visibilitySlice.reducer;
export * from './actions';
